import { combineReducers } from 'redux';
import { coreInitiativesFilesAddSyncSlice } from './add';
import { coreInitiativesFilesGetAsyncSlice } from './get';
import { coreInitiativesFilesPostAsyncSlice } from './post';
import { coreInitiativesFilesRemoveSyncSlice } from './remove';
import { coreInitiativesFilesUpdateSyncSlice } from './update';

import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { coreInitiativesFilesByIdReducers, coreInitiativesFilesByIdWatchers } from './_id';

export const coreInitiativesFilesReducers = combineReducers({
	byId: coreInitiativesFilesByIdReducers,
	get: joinCollectionReducers([
		coreInitiativesFilesGetAsyncSlice.asyncReducers,
		coreInitiativesFilesAddSyncSlice.syncReducer,
		coreInitiativesFilesRemoveSyncSlice.syncReducer,
		coreInitiativesFilesUpdateSyncSlice.syncReducer

	], coreInitiativesFilesGetAsyncSlice.asyncState),
	post: coreInitiativesFilesPostAsyncSlice.asyncReducers
});

export const coreInitiativesFilesWatchers = combineAllWatchers([
	coreInitiativesFilesByIdWatchers,
	coreInitiativesFilesGetAsyncSlice.asyncWatchers,
	coreInitiativesFilesPostAsyncSlice.asyncWatchers
]);
